import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";

// Pages
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import Program from "./pages/Program";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import AccessRequests from "./pages/AccessRequests";
import ProtectedRoutes from "./Components/ProtectedRoutes";
import AvailablePrograms from "./pages/AvailablePrograms";
import AccessRequestsUser from "./pages/AccessRequestsUser";
import EnrolledPrograms from "./pages/EnrolledPrograms";
import AccessSignupRequests from "./pages/AccessSignupRequests";
import ManageProgram from "./pages/ManageProgram";
import AddProgram from "./pages/AddProgram";
import ModuleStructure from "./pages/ModuleStructure";
import EmailVerify from "./pages/EmailVerify";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Content from "./pages/Content";
import Statistics from "./pages/Statistics";
import TwoFactorAuth from "./Components/TwoFactorAuth/TwoFactorAuth";

// Layouts
import RootLayout from "./layouts/RootLayout";
import ModuleLayout from "./layouts/ModuleLayout";

import { AuthProvider } from "./Context/AuthContext";
import { EditModeProvider } from "./Context/EditModeContext";
import NotFound from "./pages/404Page";

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<RootLayout />}>
        <Route index element={<Home />} />
        <Route path="login" element={<Login />} />
        <Route path="/2fa" element={<TwoFactorAuth />} />

        <Route path="signup" element={<Signup />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="forgot-password/:token" element={<ResetPassword />} />
        <Route
          path="profile"
          element={
            <ProtectedRoutes allowedRoles={["instructor", "user", "admin"]}>
              <Profile />
            </ProtectedRoutes>
          }
        />
        <Route
          path="programs/:id"
          element={
            <ProtectedRoutes allowedRoles={["instructor", "user", "admin"]}>
              <Program />
            </ProtectedRoutes>
          }
        />
        <Route
          path="programs/:id/manage"
          element={
            <ProtectedRoutes allowedRoles={["instructor", "admin"]}>
              <ManageProgram />
            </ProtectedRoutes>
          }
        />
        <Route
          path="myprograms"
          element={
            <ProtectedRoutes allowedRoles={["instructor", "user", "admin"]}>
              <EnrolledPrograms />
            </ProtectedRoutes>
          }
        />
        <Route
          path="myrequest"
          element={
            <ProtectedRoutes allowedRoles={["user"]}>
              <AccessRequestsUser />
            </ProtectedRoutes>
          }
        />
        <Route
          path="programs"
          element={
              <AvailablePrograms />
          }
        />
        <Route
          path="request"
          element={
            <ProtectedRoutes allowedRoles={["instructor", "admin"]}>
              <AccessRequests />
            </ProtectedRoutes>
          }
        />
        <Route
          path="signup-requests"
          element={
            <ProtectedRoutes allowedRoles={["admin"]}>
              <AccessSignupRequests />
            </ProtectedRoutes>
          }
        />
        <Route
          path="add-program"
          element={
            <ProtectedRoutes allowedRoles={["instructor", "admin"]}>
              <AddProgram />
            </ProtectedRoutes>
          }
        />
        <Route
          path="statistics"
          element={
            <ProtectedRoutes allowedRoles={["instructor", "admin"]}>
              <Statistics />
            </ProtectedRoutes>
          }
        />
      </Route>

      <Route
        path="programs/:id/module/:moduleId"
        element={
          <ProtectedRoutes allowedRoles={["instructor", "admin", "user"]}>
            <ModuleLayout />
          </ProtectedRoutes>
        }
      >
        <Route index element={<div />} />
        <Route path=":lessonId" element={<Content />} />
        <Route
          path="module-structure"
          element={
            <ProtectedRoutes allowedRoles={["instructor", "admin"]}>
              <ModuleStructure />
            </ProtectedRoutes>
          }
        />
      </Route>
      <Route path="*" element={<NotFound />} />
      <Route path="/users/:id/verify/:token" element={<EmailVerify />} />
    </>
  )
);

function App() {
  return (
    <AuthProvider>
      <EditModeProvider>
        <RouterProvider router={router} />
      </EditModeProvider>
    </AuthProvider>
  );
}

export default App;
